import { Avatar, Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { AccountMembershipsQuery } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import {
  statusTagColor,
  statusTagLabel,
} from 'modules/banking/components/AccountDetailSidepanel/SidepanelMemberships/statusUtils'

type Membership = AccountMembershipsQuery['banking']['accountMemberships'][number]

interface AccountMembershipsInfoProps {
  memberships: Membership[]
}

export const AccountMembershipsInfo = ({ memberships }: AccountMembershipsInfoProps) => {
  return (
    <Box flexDirection="column" gap="s16" paddingTop="s16">
      <Box flexDirection="column" gap="s4">
        <Text.Normal color="grey1000" weight="medium">
          {i18n.t('banking.account_memberships.section.title')}
        </Text.Normal>
        <Text color="grey800" weight="normal" size="200">
          {i18n.t('banking.account_memberships.section.subtitle')}
        </Text>
      </Box>
      {memberships.length > 0 ? (
        <Box flexDirection="column" gap="s8">
          {memberships.map((membership) => {
            return (
              <Box
                key={membership.id}
                flexDirection="row"
                alignItems="center"
                justifyContent="spaceBetween"
                gap="s8"
              >
                <Box flexDirection="row" alignItems="center" gap="s8">
                  <Avatar
                    size="s32"
                    url={buildUrl(membership.employee.avatar?.url)}
                    label={membership.employee.fullName}
                  />
                  <Text.Normal size="200" weight="medium">
                    {membership.employee.fullName}
                  </Text.Normal>
                </Box>
                <Tag type={statusTagColor[membership.status]} leftItem="circle">
                  {statusTagLabel(membership.status)}
                </Tag>
              </Box>
            )
          })}
        </Box>
      ) : (
        <Text color="grey600" size="200">
          {i18n.t('banking.account_memberships.wizard.empty_state')}
        </Text>
      )}
      <Text color="grey600" size="200">
        {i18n.t('banking.account_memberships.wizard.hint')}
      </Text>
    </Box>
  )
}
